import {StyledGrid} from 'presentation/components';
import React from 'react';
import {ProceduresCard} from '../ProceduresCard';
import {ProceduresCardGridType} from './types';

export const ProceduresCardGrid = React.memo(({list}: ProceduresCardGridType) => (
	<StyledGrid.Root spacing={2}>
		{list?.map((card, index) => (
			<StyledGrid.Item key={index} xs={12} sm={12} md={6} lg={4} xl={4}>
				<ProceduresCard procedure={card} dataTestId={`procedure-card-${index + 1}`} />
			</StyledGrid.Item>
		))}
	</StyledGrid.Root>
));
